import { FC, useState } from 'react'
import { BusinessType, UserDetailsForm } from '.'
import {
  StepCommonProps,
  JoinLayout,
  withOpenAccountCaptureDefaults,
} from '../OpenAccountPage'
import YAMLData from '../../../content/onboardingConsentDetails.yaml'
import { useFormAnalytics } from '@/hooks/useAnalytics'
import { useOnboardingSteps } from '@/context/OnboardingStepContext/OnboardingStepContext'

export const CAMPAIGN_AND_CONSENT_DETAILS = {
  source: 'organic',
  campaignName: 'unknown',
  consentName: YAMLData.consentName,
  consentVersion: YAMLData.consentVersion,
  consentText: YAMLData.consentText,
  formName: 'web_onboarding_v1',
}
export const UserDetailsStep: FC<StepCommonProps> = ({ setFormData }) => {
  const { goForward, goBack, step } = useOnboardingSteps()
  const [submissionError, setSubmissionError] = useState<Error | undefined>()
  const [trackFormSubmitted] = useFormAnalytics('marketing-mailing-list-form')

  async function submitMarketingLead(
    email: string,
    firstName?: string,
    businessType?: BusinessType,
  ) {
    setSubmissionError(undefined)
    try {
      const payload = { email, firstName, businessType }

      const response = await fetch(
        '/mettle-marketing-leads/v1/marketing-leads',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...payload, ...CAMPAIGN_AND_CONSENT_DETAILS }),
        },
      )
      if (!response.ok) {
        throw new Error(`Failed to submit: ${response.status}`)
      }
      setFormData(prev => ({
        ...withOpenAccountCaptureDefaults(prev),
        email,
        firstName: firstName ?? withOpenAccountCaptureDefaults(prev).firstName,
        businessType:
          businessType ?? withOpenAccountCaptureDefaults(prev).businessType,
      }))
      trackFormSubmitted()
      goForward()
    } catch (err: unknown) {
      setSubmissionError(
        err instanceof Error ? err : new Error('Unknown error'),
      )
    }
  }

  return (
    <JoinLayout
      title="Share your details"
      onBack={step > 0 ? goBack : undefined}
    >
      <UserDetailsForm
        onSubmit={submitMarketingLead}
        onSubmitted={() => {}}
        submissionError={submissionError}
      />
    </JoinLayout>
  )
}
